<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    name: 'AppComponent',
    mounted() {
      console.log('AppComponent mounted');
      axios.get('https://api.ipify.org?format=json')
        .then((response) => {
          const ip = response.data.ip;
          return axios.get(`/api/addvisitor/${ip}`);
        })
        .catch(() => {});
    },
  }
</script>
